import { useEffect, useState } from 'react';
import { buildQuerySummary, SearchEngine } from '@coveo/headless';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-nextjs/utils';

export const useSitesQuerySummary = (engine: SearchEngine<Record<string, never>>): number => {
  const [total, setTotal] = useState(0);
  const { sitecoreContext } = useSitecoreContext();

  useEffect(() => {
    if (isEditorActive() || sitecoreContext?.pageState === 'preview') {
      return;
    }
    if (typeof window === 'undefined') {
      return;
    }

    const controller = buildQuerySummary(engine);
    setTotal(controller.state.total);

    const unsubscribe = controller.subscribe(() => setTotal(controller.state.total));
    return () => {
      unsubscribe();
    };
  }, [engine, sitecoreContext?.pageState]);

  return total;
};

export default useSitesQuerySummary;
